import ninegrid from "../index.js";

class ngPaging extends HTMLElement
{
	#owner;
	#count;
	#url;
	#linesPerPage;
	#oldPage;
	#currentPage;
	#totalPage;
	#totalCount;
	
	constructor () {
		super();

		this.#owner = this.getRootNode().host.getRootNode().host;//this.closest("nine-grid");
		
		this.#currentPage = 0;
		this.#totalPage = 0;
		this.#totalCount = 0;
		
		this.onpagechanged = new CustomEvent('pagechanged', { bubbles: true, detail: {} });
	}
	
	connectedCallback() {
		this.innerHTML = `
			<button class="ng-paging-last" disabled></button>
			<button class="ng-paging-next" disabled></button>
			<span></span>
			<button class="ng-paging-prev" disabled></button>
			<button class="ng-paging-first" disabled></button>
			<span></span>
		`;
		
		$('.ng-paging-first', this).on("click", e => this.movePage(1));
		$('.ng-paging-prev', this).on("click", e => this.movePage(this.#currentPage - 1));
		$('.ng-paging-next', this).on("click", e => this.movePage(this.#currentPage + 1));
		$('.ng-paging-last', this).on("click", e => this.#moveLast());
	};
	
	
	get type() {
		return this.#owner.getAttribute("paging-type");
	};
	set type(v) {
		if (!Object.values(ninegrid.PAGINGTYPE).includes(v)) throw `invalid page type : ${v}`;
		
		//this.#owner.setAttribute("paging-type", v);
		
		switch (v) {
		case ninegrid.PAGINGTYPE.NONE:
			
			$(this).children().show();
			$(this).children().not("span:last-child").hide();
			break;
			
		case ninegrid.PAGINGTYPE.CLIENT:
			$(this).children().show();
			break;
			
		case ninegrid.PAGINGTYPE.SERVER:
			$(this).children().show();
			break;
		}
		
		this.refresh();
	};
	
	get currentPage() {
		return this.#currentPage;
	};
	set currentPage(v) {
		if (this.type != ninegrid.PAGINGTYPE.SERVER) throw `"currentPage" is only allowed when the paging type is server.`;
		
		this.#currentPage = v;
	};
	
	get totalCount() {
		return this.#totalPage;
	};
	set totalCount(v) {
		//if (this.type != ninegrid.PAGINGTYPE.SERVER) throw `"totalCount" is only allowed when the paging type is server.`;

		this.#totalCount = v;
		
		if (this.#currentPage <= 0) this.#currentPage = 1;
		this.#totalPage = Math.ceil(v / this.#linesPerPage);
		
		this.#refresh();
	};
	
	get linesPerPage() {
		return this.#linesPerPage;
	};
	

	get count() {
		return this.#count;
	};
	set count(v) {

		//if (!Object.values(ninegrid.PAGINGCOUNT).includes(v)) throw `invalid page count : ${v}`;
		
		setTimeout(() => {/** paging-type : none -> client 변경시 height 오류 */
			this.#count = v;
			
			if (v == ninegrid.PAGINGCOUNT.AUTO) {
				var totalHeight = $(".ng-container-body", this.#owner.body).height() - ($(".ng-container-body thead", this.#owner.body).height() || 0) - ($(".ng-container-body tfoot", this.#owner.body).height() || 0);
				var tmplHeight = 0;
				$(this.#owner.template).each((i,el) => tmplHeight += $(el).height());
				
				this.#linesPerPage = Math.floor(totalHeight / tmplHeight);

			}
			else {
				this.#linesPerPage = Number(v);
			}

			
			switch (this.type) {
			case ninegrid.PAGINGTYPE.NONE:
				this.refresh();
				break;
			
			case ninegrid.PAGINGTYPE.CLIENT:
				this.refresh();
				break;
				
			case ninegrid.PAGINGTYPE.SERVER:
				this.movePage(1);
				break;
			}
		});
	};
	
	get url() {
		return this.#url;
	};
	set url(v) {
		this.#url = v;
	}
	
	refreshTotal = () => {
	};
	
	
	#clearPaging = () => {
		
		this.#owner.data.getValidDataNF().map(m => { m.__ng.paging = true; });
		this.#owner.data.resetRecords();
	};
	
	#refresh = () => {


		if (this.type == ninegrid.PAGINGTYPE.CLIENT) {
			$('span', this).eq(1).html(`<b>Total</b> : ${this.#owner.data.countNF().toLocaleString()}`);
		}
		else if (this.type == ninegrid.PAGINGTYPE.SERVER) {
			$('span', this).eq(1).html(`<b>Total</b> : ${this.#totalCount.toLocaleString()}`);
		}
		else if (this.type == ninegrid.PAGINGTYPE.NONE) {
			$('span', this).eq(1).html(`<b>Total</b> : ${this.#totalCount.toLocaleString()}`);
		}
		
		if (this.#totalPage == 0) {
			$('span', this).eq(0).html('');
		}
		else {
			$('span', this).eq(0).html(`${this.#currentPage.toLocaleString()} <i>of</i> ${this.#totalPage.toLocaleString()}`);
		}
		
		ninegrid.j.querySelectorAll('.ng-paging-first',	this).attr("disabled", (this.#currentPage == 1 || this.#totalPage < 1) ? true : false);
		ninegrid.j.querySelectorAll('.ng-paging-prev',	this).attr("disabled", (this.#currentPage == 1 || this.#totalPage < 1) ? true : false);
		ninegrid.j.querySelectorAll('.ng-paging-next',	this).attr("disabled", (this.#currentPage == this.#totalPage || this.#totalPage < 1) ? true : false);
		ninegrid.j.querySelectorAll('.ng-paging-last',	this).attr("disabled", (this.#currentPage == this.#totalPage || this.#totalPage < 1) ? true : false);
	};
	
	
	#moveLast = () => {
		//this.#clearPaging();
		
		if (this.type == ninegrid.PAGINGTYPE.CLIENT) {

			this.movePage(Math.ceil(this.#owner.data.countNF() / this.#linesPerPage));
		}
		else if (this.type == ninegrid.PAGINGTYPE.SERVER) {
			this.movePage(Math.ceil(this.#totalCount / this.#linesPerPage));
		}
	};
	
	movePage = (page) => {
		
		//if (!this.#owner || !this.#owner.data || isNaN(page) || this.#totalPage == 0) return;
		if (!this.#owner || !this.#owner.data || isNaN(page)) return;
		
		if (this.type == ninegrid.PAGINGTYPE.SERVER) {
			ninegrid.j.querySelectorAll('.ng-paging-first',	this).attr("disabled", true);
			ninegrid.j.querySelectorAll('.ng-paging-prev',	this).attr("disabled", true);
			ninegrid.j.querySelectorAll('.ng-paging-next',	this).attr("disabled", true);
			ninegrid.j.querySelectorAll('.ng-paging-last',	this).attr("disabled", true);
		}
		
		//this.#clearPaging();
		
		this.#oldPage = this.#currentPage;
		this.#currentPage = page;
		
		if (this.type == ninegrid.PAGINGTYPE.CLIENT) {
			
			var data = this.#owner.data.getValidDataNF();
			
			this.#totalPage = Math.ceil(data.length / this.#linesPerPage);
			
			if (data.length == 0) {
				this.#totalPage = 0;
			}
			else {
				if (page < 1 || page > this.#totalPage) throw `1invalid page ${page} of ${this.#totalPage}`;
			}

			this.#refresh();
			
			/** data */
			data.map(m => { m.__ng.paging = false; });
			for (var i = (this.#currentPage - 1) * this.#linesPerPage; i < Math.min(this.#currentPage * this.#linesPerPage, this.#owner.data.countNF()); i++) {
				data[i].__ng.paging = true;
			}
			

			this.#owner.data.resetRecords();
			this.#owner.scrollTo_V1(0);
		}

		if (this.type == ninegrid.PAGINGTYPE.SERVER && this.#oldPage != this.#currentPage){
			this.onpagechanged.pageIndex= this.#currentPage;
			this.onpagechanged.pageCnt	= this.#linesPerPage;
			
			this.#owner.dispatchEvent(this.onpagechanged);
		}
	};
	
	reset = () => {
		this.refresh();
	}
	
	refresh = () => {

		switch (this.type) {
		case ninegrid.PAGINGTYPE.NONE:
			this.#clearPaging();
			$(".ng-container tbody tr.bindable:not(.nodata)", this.#owner.body).remove();
			this.#owner.scrollTo_V1(0);
			break;
		
		case ninegrid.PAGINGTYPE.CLIENT:
			this.movePage(1);
			this.#owner.refresh();
			break;
			
		case ninegrid.PAGINGTYPE.SERVER:
			break;
		}
		
		this.#refresh();
	};
}

if (!customElements.get('ng-paging')) {
	customElements.define("ng-paging", ngPaging);
}
